import newslettersInitialParams from '@/state/static/newsletters'
import productsInitialParams from '@/state/static/products'
import contactsInitialParams from '@/state/static/contacts'
import componentsInitialParams from '@/state/static/components'
import usersInitialParams from '@/state/static/users'

export default [
  {
    name: 'statistics',
    options: {},
  },
  {
    name: 'newsletters',
    options: { defaultParams: newslettersInitialParams, relationToOne: ['products', 'contacts'] },
  },
  {
    name: 'products',
    options: { defaultParams: productsInitialParams },
  },
  {
    name: 'contacts',
    options: { defaultParams: contactsInitialParams },
  },
  {
    name: 'components',
    options: { defaultParams: componentsInitialParams },
  },
  {
    name: 'users',
    options: { defaultParams: usersInitialParams },
  },
]



// WEBPACK FOOTER //
// ./state/resources.js